module.exports = __webpack_public_path__ + "img/Constant Learner.b5caef97.svg";